import { useMutation } from 'react-query'
import { axios } from '../axios'
import { queryClient } from '../reactQueryClient'
import { useNotificationStore } from '../../store/notifications'

let callData
export const deleteCall = (call) => {
  callData = call
  return axios.delete(
    call.isDynamic
      ? call.url + '?endPoint=' + call.apiEndpoint + '&id=' + call.id + call.params
      : call.url + `/${call.apiEndpoint}/${call.id}` + call.params,
  )
}

export const useDeleteCall = (call, { config } = {}) => {
  const { addNotification } = useNotificationStore()
  return useMutation(async (call) => await deleteCall(call), {
    onError: (_, __, context) => {
      if (context?.previousCall) {
        queryClient.setQueryData(call.apiEndpoint, context.previousCall)
      }
      addNotification({
        type: 'error',
        title: callData.messageTitle,
        message: 'Error! Something went wrong',
      })
    },
    onSuccess: () => {
      if (!callData.noConfirmation) {
        queryClient.invalidateQueries(
          callData.parentAPI ? callData.parentAPI : callData.apiEndpoint,
        )
        if (!callData.noConfirmation) {
          addNotification({
            type: 'success',
            title: callData.messageTitle,
            message: callData.message,
          })
        }
      }
    },
    ...config,
    mutationFn: deleteCall,
  })
}
